import { render, staticRenderFns } from "./NovoDashboardInfo.vue?vue&type=template&id=caeed12e"
import script from "./NovoDashboardInfo.vue?vue&type=script&lang=js"
export * from "./NovoDashboardInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports